var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOfficialLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1352.41 459.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard_13",
    "data-name": "Artboard 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67-7",
    "data-name": "Group 67-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65-7",
    "data-name": "Group 65-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39-7",
    "data-name": "Group 39-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33-7",
    "data-name": "Path 33-7",
    className: "cls-1",
    d: "M318.81,234.35V96.3H263V161C279.92,173.9,303.09,206.22,318.81,234.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34-7",
    "data-name": "Path 34-7",
    className: "cls-1",
    d: "M273.66,193.33h0a96.61,96.61,0,0,0-24.78-19.21c-9.68-5.83-32.27-10.27-47.21-10.27a88.27,88.27,0,0,0-33.77,6.61,80.94,80.94,0,0,0-28.46,19.64,99.64,99.64,0,0,0-19.83,32,117.09,117.09,0,0,0-7.53,43.51v.74a117.09,117.09,0,0,0,7.53,43.51,97.82,97.82,0,0,0,20,31.95,82.62,82.62,0,0,0,28.64,19.64A87.47,87.47,0,0,0,201.68,368a68.66,68.66,0,0,0,36.53-8.93A88.12,88.12,0,0,0,263,336.31a28,28,0,0,0,28,28h27.79V340.17c0-52.62-7.65-103.52-42.06-143.33Q275.24,195.08,273.66,193.33Zm-9.93,73a62.74,62.74,0,0,1-3.85,22.37,55.38,55.38,0,0,1-10.28,17.38,45.54,45.54,0,0,1-52.14,11.08,46.17,46.17,0,0,1-15.24-11.08,53.55,53.55,0,0,1-10.46-17.38,62.74,62.74,0,0,1-3.85-22.37v-.73A62.36,62.36,0,0,1,171.76,243a54,54,0,0,1,10.46-17.19,46.2,46.2,0,0,1,15.24-11.09,44.94,44.94,0,0,1,52.14,11.09,55.34,55.34,0,0,1,10.28,17.37,62.72,62.72,0,0,1,3.85,22.36Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_35-23",
    "data-name": "Path 35-23",
    className: "cls-1",
    d: "M380.29,275.05V405.94H262.08v53.6H433.87V275.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35-24",
    "data-name": "Path 35-24",
    className: "cls-1",
    d: "M56.51,194.62v-47a91.13,91.13,0,0,1,91.07-91.07h33.66V0H147.58A147.74,147.74,0,0,0,0,147.58v47Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68-5",
    "data-name": "Group 68-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36-5",
    "data-name": "Group 36-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8-5",
    "data-name": "Path 8-5",
    className: "cls-1",
    d: "M381.43,4H458a107.18,107.18,0,0,1,47.22,10A75,75,0,0,1,537.2,42.18a86.51,86.51,0,0,1,0,85.64,75,75,0,0,1-31.94,28.24A107,107,0,0,1,458,166H381.43Zm74.76,125.48a47.05,47.05,0,0,0,33.46-11.81,48.56,48.56,0,0,0,0-65.28,47,47,0,0,0-33.46-11.8H427.27v88.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9-5",
    "data-name": "Path 9-5",
    className: "cls-1",
    d: "M572.62,4h45.81V166H572.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10-5",
    "data-name": "Path 10-5",
    className: "cls-1",
    d: "M759.66,81.52h40.5v67.13a105.72,105.72,0,0,1-31.94,15.28,127.27,127.27,0,0,1-36.11,5.32,96.53,96.53,0,0,1-45.81-10.77,80.19,80.19,0,0,1-31.94-30,87.62,87.62,0,0,1,0-87,79.88,79.88,0,0,1,32.18-30A98.89,98.89,0,0,1,733.06.73,103.76,103.76,0,0,1,773.8,8.37a78.73,78.73,0,0,1,30.07,22L774.7,56.75a51.41,51.41,0,0,0-39.33-18,43.57,43.57,0,0,0-46.31,40.66,44.38,44.38,0,0,0,0,5.65,48.84,48.84,0,0,0,5.79,24,41.43,41.43,0,0,0,16.2,16.43,47.59,47.59,0,0,0,23.84,5.9A58.66,58.66,0,0,0,759.66,126Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11-5",
    "data-name": "Path 11-5",
    className: "cls-1",
    d: "M829.33,4h45.81V166H829.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12-5",
    "data-name": "Path 12-5",
    className: "cls-1",
    d: "M942.29,40.32H892.52V4h145.13V40.32H988.12V166H942.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13-5",
    "data-name": "Path 13-5",
    className: "cls-1",
    d: "M1155.25,134.53h-68.51L1074,166h-46.76L1098.77,4h45.14l71.76,162H1168Zm-13.45-33.79L1121,48.89l-20.84,51.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14-5",
    "data-name": "Path 14-5",
    className: "cls-1",
    d: "M1228.62,4h45.81V129.67h77.31V166H1228.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15-5",
    "data-name": "Path 15-5",
    className: "cls-1",
    d: "M627.16,346.25H558.64l-12.73,31.49H499.15l71.53-162h45.13l71.76,162H639.89Zm-13.45-33.79-20.83-51.85L572,312.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16-5",
    "data-name": "Path 16-5",
    className: "cls-1",
    d: "M702.46,215.7h76.63a107.28,107.28,0,0,1,47.21,10,75,75,0,0,1,32,28.24,86.53,86.53,0,0,1,0,85.65,75.05,75.05,0,0,1-32,28.24,107.28,107.28,0,0,1-47.21,10H702.46Zm74.77,125.48a47,47,0,0,0,33.45-11.81,48.52,48.52,0,0,0,0-65.27,47,47,0,0,0-33.45-11.81H748.3v88.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17-5",
    "data-name": "Path 17-5",
    className: "cls-1",
    d: "M1041.91,377.73l-.47-85.88-41.66,69.91H979.41L938,294.16v83.57H895.61v-162h37.74l56.94,93.52,55.55-93.52h37.74l.46,162Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18-5",
    "data-name": "Path 18-5",
    className: "cls-1",
    d: "M1117.54,215.7h45.84v162h-45.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19-5",
    "data-name": "Path 19-5",
    className: "cls-1",
    d: "M1351.7,215.7v162H1314l-71.52-86.34v86.34h-44.91v-162h37.74L1306.79,302V215.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37-5",
    "data-name": "Group 37-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20-5",
    "data-name": "Path 20-5",
    className: "cls-1",
    d: "M501.85,418.76h30.7v7.71H521.8v28.1h-9.35v-28.1H501.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21-5",
    "data-name": "Path 21-5",
    className: "cls-1",
    d: "M577.7,445.22a6.77,6.77,0,0,0,5.06,2,6.31,6.31,0,0,0,4.88-2,7.7,7.7,0,0,0,1.86-5.45v-21h9.36v21a16.32,16.32,0,0,1-2,8.15,13.34,13.34,0,0,1-5.62,5.39,18.34,18.34,0,0,1-8.55,1.89,18.86,18.86,0,0,1-8.61-1.89,13.58,13.58,0,0,1-5.72-5.39,16,16,0,0,1-2-8.15v-21h9.35v21A7.49,7.49,0,0,0,577.7,445.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22-5",
    "data-name": "Path 22-5",
    className: "cls-1",
    d: "M657.4,454.57l-5.21-9.91h-7v9.91h-9.34V418.76H652a16.61,16.61,0,0,1,11,3.29,11.47,11.47,0,0,1,3.91,9.28,14.13,14.13,0,0,1-1.64,7,11.34,11.34,0,0,1-4.75,4.58L668,454.57ZM645.24,437.2H652a6.34,6.34,0,0,0,4.42-1.43,5.32,5.32,0,0,0,1.55-4.14,5.14,5.14,0,0,0-1.55-4,6.42,6.42,0,0,0-4.42-1.4h-6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23-5",
    "data-name": "Path 23-5",
    className: "cls-1",
    d: "M728,418.76h8.68v35.81h-8.18l-16.25-21.41v21.41h-8.73V418.76h8.22l16.3,21.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24-5",
    "data-name": "Path 24-5",
    className: "cls-1",
    d: "M816.32,418.76h9.35v35.81h-9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25-5",
    "data-name": "Path 25-5",
    className: "cls-1",
    d: "M860.13,418.76h30.7v7.71H880.1v28.1h-9.35v-28.1H860.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26-5",
    "data-name": "Path 26-5",
    className: "cls-1",
    d: "M992.63,421a16.39,16.39,0,0,1,6.72,6.3,19.27,19.27,0,0,1,0,18.68,16.35,16.35,0,0,1-6.85,6.33,22,22,0,0,1-10.14,2.25H967.29V418.76h15.44A21,21,0,0,1,992.63,421Zm-4.88,24.72A8.63,8.63,0,0,0,991,442.1a11.82,11.82,0,0,0,1.18-5.36,11.29,11.29,0,0,0-1.25-5.41,9.14,9.14,0,0,0-3.45-3.66,9.67,9.67,0,0,0-5-1.3h-5.87V447H983a9,9,0,0,0,4.81-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27-5",
    "data-name": "Path 27-5",
    className: "cls-1",
    d: "M1037.06,418.76h9.34v35.81h-9.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28-5",
    "data-name": "Path 28-5",
    className: "cls-1",
    d: "M1107.7,436.28h8.07v14.25a23.9,23.9,0,0,1-7,3.4,26.45,26.45,0,0,1-7.89,1.3,19.73,19.73,0,0,1-9.78-2.42,18.06,18.06,0,0,1-6.88-6.67,18.41,18.41,0,0,1-2.48-9.5,17.6,17.6,0,0,1,2.58-9.43,18.09,18.09,0,0,1,7.1-6.62,21.2,21.2,0,0,1,10.09-2.4,23,23,0,0,1,8,1.46,20.58,20.58,0,0,1,6.75,3.91l-5.32,6.53a14.78,14.78,0,0,0-4.48-2.91,12.73,12.73,0,0,0-5-1.07,9.83,9.83,0,0,0-8.78,5.16,10.83,10.83,0,0,0-1.33,5.37,11.12,11.12,0,0,0,1.33,5.44,9.74,9.74,0,0,0,3.68,3.8,10,10,0,0,0,5.21,1.38,14,14,0,0,0,6.18-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29-5",
    "data-name": "Path 29-5",
    className: "cls-1",
    d: "M1152.6,418.76H1162v35.81h-9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-5",
    "data-name": "Path 30-5",
    className: "cls-1",
    d: "M1196.43,418.76h30.7v7.71H1216.4v28.1h-9.34v-28.1h-10.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-5",
    "data-name": "Path 31-5",
    className: "cls-1",
    d: "M1284.05,454.57l-2.45-6.34h-15.47l-2.49,6.34H1254l15.38-35.81h9.6l15,35.81Zm-15.12-13.49h9.91l-4.9-12.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-5",
    "data-name": "Path 32-5",
    className: "cls-1",
    d: "M1327.87,418.76h9.35v27.83h15.19v8h-24.52Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOfficialLight);
export default __webpack_public_path__ + "static/media/logo-official-light.510738afbfbddb084dd10fc61cbf9513.svg";
export { ForwardRef as ReactComponent };